<!--仓库管理 库存 库存流水-->
<template>
  <div id="inventorydetail">
    <el-row style="margin-top: 20px;">
      <el-form :inline="true" class="demo-form-inline" :model="searchForm" :ref="searchForm" style="margin: 0">
        <el-col :xl="8" :lg="12" :md="16">
          <el-form-item label="选择日期：">
            <el-date-picker size="medium" v-model="searchForm.START_END" type="datetimerange" value-format="yyyy-MM-dd"
              range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" clearable>
            </el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :xl="1" :lg="1" :md="4">
          <el-button size="medium" type="primary" @click="search()" :loading="loading">筛选</el-button>
        </el-col>
      </el-form>
    </el-row>
    <el-row>
      <h5>公司名称：{{ PROJECT_NAME }}</h5>
      <h5>商品名称：{{ PRODUCT_NAME }}</h5>
      <el-col :span="24" style="margin-top:20px">
        <el-table :data="tableData" stripe border style="width: 100%">
          <el-table-column prop="OPERATION_TYPE_NAME" label="操作"></el-table-column>
          <el-table-column prop="COMMENT" label="备注"></el-table-column>
          <el-table-column prop="SEND_DAY" label="送货日期"></el-table-column>
          <el-table-column prop="SUPPLIER_NAME" label="供应商"></el-table-column>
          <el-table-column prop="PROJECT_NAME" label="项目点"></el-table-column>
          <el-table-column prop="DK_NAME" label="档口"></el-table-column>
          <el-table-column prop="LOCATION_CODE" label="库位" v-if="WAREHOUSE_MODE == 2"></el-table-column>
          <el-table-column prop="OPERATOR_NAME" label="操作人" min-width="50"></el-table-column>
          <el-table-column prop="OPERATION_TIME" label="操作时间" min-width="120"></el-table-column>
          <el-table-column prop="PRODUCT_COUNT" label="数量"></el-table-column>
          <el-table-column prop="AFTER_COUNT" label="余量"></el-table-column>
          <el-table-column prop="AFTER_FEE" label="剩余金额"></el-table-column>
        </el-table>
      </el-col>
    </el-row>
    <!-- 分页 -->
    <div class="pagination_box">
      <el-pagination @current-change="handleCurrentChange" :current-page.sync="currentPage" :page-size="pageSize"
        layout="total,prev, pager, next, jumper" :total="total_count">
      </el-pagination>
    </div>
  </div>
</template>
<script>
import { querystockFun } from 'api/warehouseManager';

export default {
  data () {
    return {
      loading: false,
      tableData: [],
      searchForm: {},
      total_count: 0,
      pageSize: 20,
      currentPage: 1,
      PROJECT_NAME: '',
      PRODUCT_NAME: '',
      WAREHOUSE_MODE: sessionStorage.getItem('WAREHOUSE_MODE'),
    };
  },
  created () {
    // 这里用来在设置中设置页面展示条目，文件在setting的generalSettings中，由前端控制条目，存储于localStorage中，key为SMP_PAGE_COUNT
    this.pageSize = Number(localStorage.getItem('SMP_PAGE_COUNT')) ? Number(localStorage.getItem('SMP_PAGE_COUNT')) : 10;
    if (this.SAVE_DSORDER_LIST) {
      this.searchForm = this.SAVE_DSORDER_LIST.CONDITION;
      this.currentPage = this.SAVE_DSORDER_LIST.CURRENT_PAGE;
    } else {
      this.currentPage = 1;
    }
    this.queryStockDetail();
  },
  methods: {
    queryStockDetail () {
      const params = {
        BATCH: sessionStorage.getItem('BATCH'),
        PRODUCT_CODE: sessionStorage.getItem('PRODUCT_CODE'),
        PAGEINDEX: this.currentPage - 1,
        PAGESIZE: this.pageSize,
      };
      if (this.searchForm.START_END) {
        params.START_DAY = this.searchForm.START_END[0];
        params.END_DAY = this.searchForm.START_END[1];
      }
      this.loading = true;
      querystockFun(params).then((result) => {
        if (result.length !== 0) {
          this.PROJECT_NAME = result[0].GYS_NAME;
          this.PRODUCT_NAME = sessionStorage.getItem('PRODUCT_NAME');
          this.tableData = result[0].list;
          this.total_count = result[0].TOTAL_COUNT;
        } else {
          this.PROJECT_NAME = '';
          this.PRODUCT_NAME = '';
          this.tableData = [];
          this.total_count = 0;
        }
        this.loading = false;
      }).catch((error) => {
        this.loading = false;
        this.$message.show({ text: error, type: 'error' });
      });
    },
    handleCurrentChange (e) {
      this.currentPage = e;
      this.queryStockDetail();
    },
    search () {
      this.currentPage = 1;
      this.queryStockDetail();
    },
  },
};
</script>
<style scoped>
h5 {
  float: left;
  margin: 0 10px;
}

.pagination_box {
  float: right;
}
</style>



// WEBPACK FOOTER //
// src/components/warehouseManage/stockListDetail.vue